import axios from 'axios';
import axiosInstance from '../utils/axios';

const subdomain = process.env.REACT_APP_SHADOWSTREAM_SUB || 'genflux';

const API_URL = `https://${subdomain}-server.shadowstream.world/api/auth/`;

export const login = async (username, password) => {
  const response = await axios.post(`${API_URL}login/`, { username, password });
  // Assuming the response contains a user object and token
  return response.data;
};

export const logout = async () => {
  await axios.post(`${API_URL}logout/`);
};

export const fetchUser = async () => {
  const response =  await axiosInstance.get('auth/user/')
  return response.data
};

export const fetchUserWithProfile = async (pk) => {
  const response =  await axiosInstance.get('users/' + pk)
  return response.data
};


export const register = async (username, password1, password2) => {
  const response = await axios.post(`${API_URL}registration/`, {
    username,
    password1,
    password2,
  });
  // Assuming the response contains a user object and token
  return response.data;
};
